"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentTypes_1 = require("./ComponentTypes");
var Window_1 = require("./Window");
var Stack_1 = require("./Stack");
var Split_1 = require("./Split");
var Grid_1 = require("./Grid");
var ComponentFactoryMap = {};
exports.ComponentFactoryMap = ComponentFactoryMap;
ComponentFactoryMap[ComponentTypes_1.window] = function () {
    return new Window_1.Window();
};
ComponentFactoryMap[ComponentTypes_1.stack] = function () {
    return new Stack_1.Stack();
};
ComponentFactoryMap[ComponentTypes_1.hsplit] = function () {
    return new Split_1.HSplit();
};
ComponentFactoryMap[ComponentTypes_1.vsplit] = function () {
    return new Split_1.VSplit();
};
ComponentFactoryMap[ComponentTypes_1.grid] = function () {
    return new Grid_1.Grid();
};
var ComponentFactory = function (type) {
    var s = ComponentFactoryMap[type];
    if (s) {
        return s();
    }
    throw { code: "NOT_FOUND", type: type, message: "Component Type " + type + " is not registered" };
};
exports.ComponentFactory = ComponentFactory;
